module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "width": "100%",
      "margin-top": "-10px"
    }
  }, [(_vm.orderDetail.desUserId) ? _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "设计师信息"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.orderDetail.desUserCode))])])]), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.orderDetail.desNickName))])])]), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.orderDetail.desPhone))])])]), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('dict-tag', {
    attrs: {
      "dict": "biz_des_level",
      "value": _vm.orderDetail.desUserLevel
    }
  })], 1)])], 1) : _c('div', {
    staticClass: "order-input-wrap"
  }, [_vm._m(4)]), _vm._v(" "), (_vm.orderDetail.servCataId == '3010130' && _vm.orderDetail.desUserId) ? _c('detail-data', {
    attrs: {
      "label": "矫治方案",
      "isDown": false,
      "fileList": _vm.fileDataList.designCorrectPlan,
      "servOrderId": _vm.orderDetail.servOrderId,
      "servCataId": _vm.orderDetail.servCataId,
      "orthodonticsData": _vm.orderDetail.orthodonticsData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orderDetail.servCataId == '3010130' && _vm.orderDetail.desUserId) ? _c('detail-data', {
    attrs: {
      "label": "模拟视频",
      "isDown": false,
      "fileList": _vm.fileDataList.designAnalogVideo,
      "servOrderId": _vm.orderDetail.servOrderId,
      "servCataId": _vm.orderDetail.servCataId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designMake && _vm.orderDetail.desUserId && _vm.orderDetail.servCataId == '3010130') ? _c('detail-data', {
    attrs: {
      "label": "CNC制造文件",
      "isDown": false,
      "fileList": _vm.orderDetail.designMake,
      "servOrderId": _vm.orderDetail.servOrderId,
      "servCataId": _vm.orderDetail.servCataId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designData && _vm.orderDetail.desUserId && _vm.orderDetail.servCataId == '3010130') ? _c('detail-data', {
    attrs: {
      "label": "设计方案源文件",
      "isDown": false,
      "fileList": _vm.orderDetail.designData,
      "servOrderId": _vm.orderDetail.servOrderId,
      "servCataId": _vm.orderDetail.servCataId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.orderDetail.servCataId).isDesignData === '1' && _vm.orderDetail.desUserId && !_vm.plateShow && _vm.orderDetail.servCataId != '3010130') ? _c('detail-data', {
    attrs: {
      "label": "设计文件",
      "isDown": false,
      "fileList": _vm.orderDetail.designData,
      "servOrderId": _vm.orderDetail.servOrderId,
      "servCataId": _vm.orderDetail.servCataId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.orderDetail.servCataId).isDesignReport === '1' && _vm.orderDetail.desUserId && !_vm.plateShow) ? _c('detail-data', {
    attrs: {
      "label": "手术报告",
      "fileList": _vm.orderDetail.designReport,
      "servCataId": _vm.orderDetail.servCataId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.orderDetail.servCataId).isDesignReport === '1' && _vm.orderDetail.desUserId && _vm.plateShow) ? _c('detail-data', {
    attrs: {
      "label": "种植导板手术规划报告(PDF格式)",
      "fileList": _vm.orderDetail.designReport,
      "servCataId": _vm.orderDetail.servCataId,
      "report": _vm.orderDetail.designReport
    }
  }) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.orderDetail.servCataId).isDesignGuide === '1' && _vm.orderDetail.desUserId && !_vm.plateShow) ? _c('detail-data', {
    attrs: {
      "label": "钻针指南文件",
      "fileList": _vm.orderDetail.designGuide,
      "servCataId": _vm.orderDetail.servCataId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.orderDetail.servCataId).isDesignGuide === '1' && _vm.orderDetail.desUserId && _vm.plateShow) ? _c('detail-data', {
    attrs: {
      "label": "器械钻针使用流程及注意事项(PDF格式)",
      "fileList": _vm.orderDetail.designGuide,
      "servCataId": _vm.orderDetail.servCataId,
      "guide": _vm.orderDetail.designGuide
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orderDetail.desUserId && _vm.orderDetail.orderStatus == '99' && !_vm.plateShow && _vm.orderDetail.servCataId != '3010130') ? _c('detail-data', {
    attrs: {
      "label": "制造文件",
      "fileList": _vm.orderDetail.designMake
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orderDetail.orderStatus == '99' && _vm.orderDetail.desUserId && _vm.plateShow) ? _c('detail-data', {
    attrs: {
      "label": "种植导板制造文件",
      "fileList": _vm.orderDetail.designMake
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orderDetail.orderStatus == '99' && _vm.orderDetail.servCataId == '3010130') ? _c('el-button', {
    staticClass: "resetBtn",
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "mini"
    }
  }, [_vm._v("重启设计需全额缴费，请严格按照确认的矫治方案佩戴矫治牙套")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("设计师编号：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("设计师：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("联系方式：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("设计师级别：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-file"
  }, [_c('i', {
    staticClass: "el-icon-warning-outline"
  }), _vm._v(" "), _c('span', [_vm._v("暂无设计师接单")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f44ef44","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/detailDesign.vue
// module id = 671
// module chunks = 0